import angular from 'angular';
import { HistoricoPedidoModule } from './pedido/historico-pedido.module';

export const HistoricoModule = 'mandaeApp.historico';

angular.module(HistoricoModule, [
  HistoricoPedidoModule,
]);
